export default "__VITE_ASSET__Doq9IJ12__"